import React, { useEffect } from 'react'
import styles from './HardArea.module.css'
import { useNavigate } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';

export type HardAreaProps = {
    img: string;
    title: string;
    theme: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    setTheme: React.Dispatch<React.SetStateAction<string>>;
}

const HardArea = (props: HardAreaProps) => {

    const navigate = useNavigate();
    const { ref, inView } = useInView({
        threshold: 0.5, // 50% visible
        triggerOnce: false, // Change theme every time it enters view (optional)
    });

    const clickHardArea = () => {
        props.setSearch(props.title)
        navigate("/projects");
    }

    useEffect(() => {
        if (inView) {
            props.setTheme(props.theme);
        }
    }, [inView]);

    return (
        <div ref={ref} className={styles.hardArea} onClick={() => clickHardArea()} style={{backgroundImage: `url(${props.img})`}}>
            <h2>{props.title}</h2>
        </div>
    )
}

export default HardArea
